<script lang="ts" setup>
import UsersMenu from '../components/users/UsersMenu.vue';
import UsersList from '../components/users/UsersList.vue';
import CommunitiesList from '../components/users/CommunitiesList.vue';
import OrganizationsList from '../components/users/OrganizationsList.vue';

import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <UsersMenu />
  <UsersList v-if="route.path === '/users'" />
  <CommunitiesList v-if="route.path === '/users/communities'" />
  <OrganizationsList v-if="route.path === '/users/organizations'" />
</template>
